import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { ViewPageLiteProps } from '../src/ViewPageLite.tsx';

export const ViewPageLiteLoader: LoadableType<ViewPageLiteProps> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ViewPageLite" */ '../src/ViewPageLite.tsx'))
			.ViewPageLite,
});
